import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import pdf from 'assets/img/pdf.png';
import xls from 'assets/img/xls.png';
import xml from 'assets/img/xml.png';
import doc from 'assets/img/doc.png';
import file from 'assets/img/file.png';

class FilePreview extends PureComponent {
  static propTypes = {
    file: PropTypes.object.isRequired,
  };

  imagesExt = ['jpg', 'jpeg', 'png', 'gif'];

  state = { src: null };

  componentWillMount = () => {
    const ext = this.props.file.name.split('.').pop().toLowerCase();

    if (this.imagesExt.indexOf(ext) > -1) {
      const reader = new FileReader();
      reader.readAsDataURL(this.props.file);
      reader.onloadend = () => this.setState({ src: reader.result });
    } else {
      switch (ext) {
        case 'pdf':
          this.setState({ src: pdf });
          break;
        case 'xls':
        case 'xlsx':
        case 'csv':
          this.setState({ src: xls });
          break;
        case 'xml':
          this.setState({ src: xml });
          break;
        case 'doc':
        case 'docx':
          this.setState({ src: doc });
          break;
        default:
          this.setState({ src: file });
          break;
      }
    }
  };

  render = () => (
    <img
      src={this.state.src}
      alt={this.props.file.name}
      style={{ height: '100px', padding: '10px' }}
    />
  );
}

export default FilePreview;



// WEBPACK FOOTER //
// src/modules/common/components/FilePreview.js